import React, { useEffect, useState } from "react";
import "./ProductionPlanning.css"
import {
    Grid,
    Container,
    Typography,
    Table,
    TableBody,
    TableRow,
    TableCell,
    TablePagination,
    TableHead,
    Modal,
} from "@mui/material";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import { images } from "../../config/images";
import { Button } from "../../components/Button/button";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import SearchIcon from "@mui/icons-material/Search";
import Loader from "../../components/Loader/Loader";
import Expand from "./Expand";
import { userFootFallTracking } from "../FootFallReport/services";

const ProductionPlanning = () => {
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false);
    const initiallValue = {
        Status: "",
        day_left: "",
        order_id: "",
        customer_name: "",
        order_quantity: "",
        packed_quantity: "",
        dispatched_quantity: "",
    };
    const [searchText, setSearchText] = useState(initiallValue);

    const handleSearchData = async (e) => {
        if (e.target) {
            const { name, value } = e.target;
            setSearchText({ ...searchText, [name]: value });
        }

    };
    const [expandedRows, setExpandedRows] = useState({});

    const handleToggleExpand = (orderId) => {
        setExpandedRows((prevState) => ({
            ...prevState,
            [orderId]: !prevState[orderId],
        }));
    };
    const tableData = [
        {
            status: "Work in Progress",
            days_left: 10,
            order_id: "DEA0010107",
            customer_name: "JSW Steel Limited",
            order_quantity: 30,
            packed_quantity: 5,
            dispatch_quantity: 5,
            details: {
                order_date: "22/01/2022",
                promise_date: "10/06/2022",
                type: "CPUC Pipe",
                size: "1/2'",
            },
        },
        {
            status: "Packed",
            days_left: 15,
            order_id: "DEA0010108",
            customer_name: "Ideal Electrify Shop LLP",
            order_quantity: 30,
            packed_quantity: 5,
            dispatch_quantity: 5,
            details: {
                order_date: "25/01/2022",
                promise_date: "15/06/2022",
                type: "CPUC Pipe",
                size: "3/4'",
            },
        },
        {
            status: "Packed",
            days_left: 20,
            order_id: "DEA0010109",
            customer_name: "Ceylon Electricity Board",
            order_quantity: 30,
            packed_quantity: 5,
            dispatch_quantity: 5,
            details: {
                order_date: "25/01/2022",
                promise_date: "15/06/2022",
                type: "CPUC Pipe",
                size: "3/4'",
            },
        },
        {
            status: "Work in Progress",
            days_left: 20,
            order_id: "DEA0010110",
            customer_name: "Ceylon Electricity Board",
            order_quantity: 30,
            packed_quantity: 5,
            dispatch_quantity: 5,
            details: {
                order_date: "25/01/2022",
                promise_date: "15/06/2022",
                type: "CPUC Pipe",
                size: "3/4'",
            },
        },
        {
            status: "Work in Progress",
            days_left: 22,
            order_id: "DEA0010111",
            customer_name: "Success Udyog Pvt Ltd",
            order_quantity: 30,
            packed_quantity: 5,
            dispatch_quantity: 5,
            details: {
                order_date: "25/01/2022",
                promise_date: "15/06/2022",
                type: "CPUC Pipe",
                size: "3/4'",
            },
        },
        {
            status: "Open",
            days_left: 22,
            order_id: "DEA0010160",
            customer_name: "Success Udyog Pvt Ltd",
            order_quantity: 30,
            packed_quantity: 0,
            dispatch_quantity: 5,
            details: {
                order_date: "25/01/2022",
                promise_date: "15/06/2022",
                type: "CPUC Pipe",
                size: "3/4'",
            },
        },

    ];

   



      useEffect(() => {
        let intervalId = null;
    
        const callUserFootFallTracking = () => {
          const moduleList = JSON.parse(localStorage.getItem("moduleList"));
          if (moduleList) {
            const module = moduleList.find((m) => m.name === "Production Planning");
            if (module) {
              const params = { module_id: module.id };
              try {
                userFootFallTracking(params);
              } catch (error) {
                console.error("Error calling userFootFallTracking:", error);
              }
            }
          }
        };
    
        const startTracking = () => {
          if (!intervalId) {
            console.log("▶️ Start API interval");
            callUserFootFallTracking(); // call immediately
            intervalId = setInterval(callUserFootFallTracking, 5 * 60 * 1000);
          }
        };
    
        const stopTracking = () => {
          if (intervalId) {
            console.log("⏹ Stop API interval");
            clearInterval(intervalId);
            intervalId = null;
          }
        };
    
        const handleVisibilityChange = () => {
          if (document.hidden) {
            stopTracking(); // stop when tab hidden/minimized
          } else {
            startTracking(); // resume when tab active
          }
        };
    
        // Setup listener
        document.addEventListener("visibilitychange", handleVisibilityChange);
    
        // Start tracking immediately if tab is visible
        if (!document.hidden) {
          startTracking();
        }
    
        return () => {
          stopTracking();
          document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
      }, []);
    return (
        <>

            <div className="containerWrap">
                <Container maxWidth="xxl">
                    <div className="packingHeader-wrap">
                        <div className="packingTitle-wrap">
                            <KeyboardBackspaceIcon
                                onClick={() => navigate("/dashboard")}
                                className="backArrow"
                            />
                            <Typography
                                variant="h5"
                                className="packingTitle"
                                gutterBottom
                                onClick={() => navigate("/dashboard")}
                            >
                                Production Planning
                            </Typography>
                        </div>
                        <div className="dispatchSummary-print-section">
                            <Button
                                title="Filter"
                                classname={"border-btn"}
                                onClick={() => navigate("/dispatch-print-preview")}
                                style={{
                                    width: "120px", backgroundColor: "white",
                                    border: "1px solid #475467",
                                    color: "#3C4856"
                                }}
                            />
                            <Button
                                title="Upload CSV"
                                classname={"border-btn"}
                                onClick={() => navigate("/dispatch-print-history")}
                                style={{
                                    width: "120px", backgroundColor: "white",
                                    border: "1px solid #475467",
                                    color: "#3C4856"
                                }}
                            />
                            <img src={images.sheetIcon} />
                        </div>
                    </div>

                    <Table
                        className="prod-table"
                    >
                        <TableHead className="prod-table-head">
                            <TableRow className="prod-table-headRow">
                                <TableCell colSpan={2} className="prod-table-headCell">Status</TableCell>
                                <TableCell className="prod-table-headCell">Days Left</TableCell>
                                <TableCell className="prod-table-headCell">Order Id</TableCell>
                                <TableCell className="prod-table-headCell">Customer Name</TableCell>
                                <TableCell className="prod-table-headCell">Order Quantity</TableCell>
                                <TableCell className="prod-table-headCell">Packed Quantity</TableCell>
                                <TableCell colSpan={2} className="prod-table-headCell">Dispatch Quantity</TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell colSpan={2} className="search-table-row">
                                    <SearchIcon className="search-icon" />
                                    <input
                                        type="search"
                                        placeholder="Status"
                                        name="Status"
                                        value={searchText.Status}
                                        onChange={handleSearchData}
                                    />
                                </TableCell>
                                <TableCell className="search-table-row">
                                    <SearchIcon className="search-icon" />
                                    <input
                                        type="search"
                                        placeholder="day_left"
                                        name="day_left"
                                        value={searchText.day_left}
                                        onChange={handleSearchData}
                                    />
                                </TableCell>
                                <TableCell className="search-table-row">
                                    <SearchIcon className="search-icon" />
                                    <input
                                        type="search"
                                        placeholder="Order ID"
                                        name="order_id"
                                        value={searchText.order_id}
                                        onChange={handleSearchData}
                                    />
                                </TableCell>
                                <TableCell className="search-table-row">
                                    <SearchIcon className="search-icon" />
                                    <input
                                        type="search"
                                        placeholder="Customer Name"
                                        name="customer_name"
                                        value={searchText.customer_name}
                                        onChange={handleSearchData}
                                    />
                                </TableCell>
                                <TableCell className="search-table-row">
                                    <SearchIcon className="search-icon" />
                                    <input
                                        type="search"
                                        placeholder="Order Quantity"
                                        name="order_quantity"
                                        value={searchText.order_quantity}
                                        onChange={handleSearchData}
                                    />
                                </TableCell>
                                <TableCell className="search-table-row">
                                    <SearchIcon className="search-icon" />
                                    <input
                                        type="search"
                                        placeholder="Packed Quantity"
                                        name="packed_quantity"
                                        value={searchText.packed_quantity}
                                        onChange={handleSearchData}
                                    />
                                </TableCell>
                                <TableCell colSpan={2} className="search-table-row">
                                    <SearchIcon className="search-icon" />
                                    <input
                                        type="search"
                                        placeholder="Dispatch Quantity"
                                        name="dispatched_quantity"
                                        value={searchText.dispatched_quantity}
                                        onChange={handleSearchData}
                                    />
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody className="prod-table-body">
                            {tableData.map((row, index) => (
                                <Expand
                                    key={row.order_id}
                                    row={row}
                                   index={index}
                                />
                            ))}

                            {isLoading && <Loader />}
                        </TableBody>
                    </Table>
                    <div className="d-flex justify-content-between aborted">
                        <div className="d-flex align-items-center">
                            <div
                                style={{ color: "#001323", marginRight: "25px" }}
                                className="d-flex align-items-center"
                            >
                                <span className="passed-btn m-1"></span>High
                            </div>
                            <div
                                style={{ color: "#001323", marginRight: "25px" }}
                                className="d-flex align-items-center"
                            >
                                <span className="rejected-btn1 m-1"></span>Medium
                            </div>
                            <div
                                style={{ color: "#001323" }}
                                className="d-flex align-items-center"
                            >
                                <span className="pending-btn m-1"></span>Low
                            </div>
                        </div>
                    </div>

                </Container>
            </div>
        </>
    )
}

export default ProductionPlanning;